import axios from 'axios';
import apiConfig from '../api.config';

export default function doorOpeningDeleteToHotelRequest({ hotelId, doorOpeningId }) {
  const {
    host,
    URIs: { deleteDoorOpeningToHotel },
  } = apiConfig;

  const uri = `${host}${deleteDoorOpeningToHotel
    .replace(':hotelId', hotelId)
    .replace(':doorId', doorOpeningId)}`;

  return axios
    .delete(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
